module.exports = __webpack_public_path__ + "img/icon-3.241cc4ef.png";